import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Confidencialidad from '../images/confidencialidad.svg';
import Eficiencia from '../images/eficiencia.svg';
import Cliente from '../images/cliente.svg';
import Vision from '../images/vision.svg';
import '../styles/HomePage.css';
import Procesos from "../images/procesos.png";
import Datos from "../images/datos.png";
import Automatizar from "../images/automatizar.png";
import Transformar from "../images/transformar.png";


export function HomePage() {
    const [currentBenefit, setCurrentBenefit] = useState(0);
    const benefits = [
        { img: Confidencialidad, title: "Confidencialidad" },
        { img: Eficiencia, title: "Eficiencia" },
        { img: Cliente, title: "Enfoque al cliente" }
    ];

    const nextBenefit = () => {
        setCurrentBenefit((prev) => (prev + 1) % benefits.length);
    };

    const prevBenefit = () => {
        setCurrentBenefit((prev) => (prev - 1 + benefits.length) % benefits.length);
    };

    return (
        <Box className="box-home">
            <Grid container spacing={2}>

                <Grid size={12} className="section-home">
                    <div className="overlay"></div>
                    <Grid size={12} className="section1-home">
                        <h1>TODA HISTORIA COMIENZA CON UN <span style={{ color: '#D4AF37' }}>DATO</span></h1>
                        <p>Transformación digital para procesos legales y administrativos</p>
                    </Grid>
                </Grid>

                <Grid size={12} className="section-info">
                    <div className="overlay2"></div>
                    <Grid size={12} className="section1-info">
                        <p>En <span style={{ color: '#D4AF37' }}>Legabot</span> combinamos la experiencia jurídica con 
                        tecnología de punta para digitalizar, revisar y optimizar tus procesos legales.</p>
                    </Grid>
                </Grid>


                <Grid size={12} container
                    direction="column"
                    alignItems="center"
                    style={{ textAlign: "center" }}
                    bgcolor={"#F2EDE7"}>
                    <h1 style={{ fontSize: '40px', color: "#D4AF37", marginTop: "60px" }}>¿POR QUÉ NOSOTROS?</h1>

                    <Grid container spacing={{ xs: 0, md: 4 }} className="section2-home">
                        <Grid size={{ xs: 12, md: 4 }} className="grid-section2">
                            <img src={Confidencialidad} />
                            <h1>Confidencialidad</h1>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className="grid-section2" sx={{
                            mt: { xs: -12,md:0 },
                        }}>
                            <img src={Eficiencia} alt="Eficiencia" />
                            <h1>Eficiencia</h1>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className="grid-section2" sx={{
                            mt: { xs: -12,md:0 },
                        }}>
                            <img src={Cliente} alt="Enfoque al cliente" />
                            <h1>Enfoque al cliente</h1>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid size={12} container
                    direction="column"
                    alignItems="center"
                    style={{ textAlign: "center" }}
                    className="visionSection">

                    <h1 style={{ fontSize: '40px', color: "#D4AF37" }}>NUESTRA VISIÓN</h1>

                    <Grid container spacing={2} sx={{
                        mt: { xs: 0, md: 0 },
                        mx: { xs: 2, md: 10 },
                        my: { xs: 2, md: 5 }
                    }}>

                        <Grid size={{ xs: 12, md: 6 }} className="visionDescription">
                            <p>Nuestra visión es liderar la modernización del sector
                                legal con transformación y automatización digital.</p>
                            <p> Apuntamos a nuevos estándares en eficiencia y
                                la satisfacción del cliente utilizando los últimos
                                avances tecnológicos.</p>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className="visionPhoto">
                            <img
                                src={Vision}
                                alt="Gráfica vision"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={12} container
                    direction="column"
                    alignItems="center"
                    style={{ textAlign: "center" }}
                    bgcolor={"#F2EDE7"}>
                    <h1 style={{ marginTop: '20px', marginBottom: '60px', fontSize: '40px', color: "#D4AF37" }}>LO QUE HACEMOS</h1>

                    <Grid container spacing={2} className="section5-home">
                        <Grid size={{ xs: 12, md: 6 }} className="grid-section5" sx={{
                                ml: { xs: 0, md: 6 }  
                            }}>
                            <div className="image-container" >
                                <img src={Procesos} alt="MEJORAR PROCESOS" />
                                <div className="overlay3"></div>
                                <div className="container">
                                    <h1 className="title">MEJORAR PROCESOS</h1>
                                    <p className="text">Entender, normar y eficientar procesos.</p>
                                </div>
                            </div>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="grid-section5" sx={{
                                ml: { xs: 0, md: -10 }  
                            }}>
                            <div className="image-container" >
                                <img src={Datos} alt="USAR DATOS" />
                                <div className="overlay3"></div>
                                <div className="container">
                                    <h1 className="title">USAR DATOS</h1>
                                    <p className="text">Entender, normar y eficientar procesos.</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className="grid-section5" sx={{
                                ml: { xs: 0, md: 6 }  
                            }}>
                            <div className="image-container" >
                                <img src={Automatizar} alt="AUTOMATIZAR" />
                                <div className="overlay3"></div>
                                <div className="container">
                                    <h1 className="title">AUTOMATIZAR</h1>
                                    <p className="text">Aplicamos inteligencia artificial para automatizar procesos.</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className="grid-section5" sx={{
                                ml: { xs: 0, md: -10 }  
                            }}>
                            <div className="image-container" >
                                <img src={Transformar} alt="TRANSFORMAR" />
                                <div className="overlay3"></div>
                                <div className="container">
                                    <h1 className="title">TRANSFORMAR</h1>
                                    <p className="text">Planear y proponer nuevas formas de trabajo.</p>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={12} className="section6">
                    <Grid size={12}>
                        <p>¿Listo para transformar tus procesos legales?</p>
                        <button className="button-propuesta">Enviar propuesta ahora</button>
                    </Grid>

                </Grid>
            </Grid>
        </Box>
    );
}

